import { CookiesConstants, LocalStorageConstants } from "utils/constants";
import {
  TypeClickStreamselector,
  TypeSearchSource,
} from "../types/clickStreamTypes";
import isBrowser from "utils/misc/isBrowser";
import { EnumScreenNames } from "../../../enums/EnumScreenNames";
import {destroyCookie, setCookie} from "utils/nookies";
import {TypeLoggingSelector} from "../../logging/types/loggingTypes";

export function setClickStreamSearchSource(source: TypeSearchSource) {
  if (isBrowser) {
    localStorage.setItem(LocalStorageConstants.SEARCH_SOURCE, source);
    setCookie(null, CookiesConstants.SEARCH_SOURCE, source,{
      expires: new Date(
          new Date().getTime() +
          Number(process.env.NEXT_PUBLIC_SESSION_ID_EXPIRED_IN_MINUTES) * 60000
      ),
    });
  }
}

export function getClickStreamSearchSource(): TypeSearchSource {
  if (isBrowser)
    return localStorage.getItem(
      LocalStorageConstants?.SEARCH_SOURCE
    ) as TypeSearchSource;
}

export function setClickStreamSearchID(searchID: string) {
  if (isBrowser)
    localStorage?.setItem(LocalStorageConstants.SEARCH_ID, searchID);
}

export function getClickStreamSearchID(): string {
  if (isBrowser) return localStorage?.getItem(LocalStorageConstants.SEARCH_ID);
}

export function resetClickStreamSearchID() {
  if (isBrowser) localStorage?.setItem(LocalStorageConstants.SEARCH_ID, "");
}

export function resetClickStreamSearchSource() {
  localStorage.setItem(LocalStorageConstants.SEARCH_SOURCE, "");
  destroyCookie(null, CookiesConstants.SEARCH_SOURCE);
}

export function getLastThreeScreens(): EnumScreenNames[] {
  if (isBrowser)
    return localStorage
      .getItem("last_three_screens")
      ?.split(",") as EnumScreenNames[];
}

export function getCurrentScreen(): EnumScreenNames {
  if (isBrowser)
    return localStorage.getItem("currentScreen") as EnumScreenNames;
}

export function checkIfSelectorMatchTargeted(
  attr: "class" | "id",
  clickedEle: HTMLElement,
  selector: TypeClickStreamselector | TypeLoggingSelector
) {
  return (
    clickedEle?.getAttribute(attr)?.includes(selector) ||
    clickedEle?.parentElement?.getAttribute("class")?.includes(selector)
  );
}

export function checkIfContainsTargeted(
  targetedEle: HTMLElement,
  selector: TypeClickStreamselector | TypeLoggingSelector
) {
  let eleByID = document.querySelectorAll(`#${selector}`);
  let eleByClass = document.querySelectorAll(`.${selector}`);
  const selectedElements = !!eleByClass.length ? eleByClass : eleByID;
  // return parent.filter((ele) => ele.contains(htmlEle) || htmlEle === ele).length;
  let res = false;
  for (const ele of selectedElements) {
    if (ele.contains(targetedEle) || targetedEle === ele) res = true;
  }
  return res;
}
